import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
} from "@mui/material";
import {
  FormContainer,
  SelectHookForm,
  AutocompleteHookFormAsync,
  TextFieldHookForm,
  Button,
  Save01Icon,
  LoadingOverlay,
} from "components";
import { EmployeeRoleOptions } from "services";
import { i18n } from "translations";
import { rem } from "utils";

import { useEmployeeDialog } from "./hook";

interface Props {
  show: boolean;
  onToggle: () => void;
}

const EmployeeDialog = (props: Props) => {
  const { show = false, onToggle = () => {} } = props;
  const { EmployeeFormSchema, loading, handleSubmit, nodeSelected } =
    useEmployeeDialog({
      onToggle,
    });
  return (
    <Dialog
      open={show}
      onClose={onToggle}
      fullWidth
      PaperProps={{
        sx: {
          overflow: "unset",
        },
      }}
    >
      <FormContainer schema={EmployeeFormSchema} onSubmit={handleSubmit}>
        <LoadingOverlay loading={loading} noPadding noBgColor>
          <DialogTitle>
            {i18n.t("addManager")} ({nodeSelected?.name || ""})
          </DialogTitle>
          <DialogContent>
            <Stack rowGap={rem(16)} pt={2}>
              <AutocompleteHookFormAsync
                name="employee"
                label={i18n.t("employee")}
                placeholder={i18n.t("selectEmployee")}
                model="employee"
                keyLabel="fullName"
                keySubLabel="email"
                required
              />
              <SelectHookForm
                name="role"
                label={i18n.t("role")}
                options={EmployeeRoleOptions}
                placeholder={i18n.t("selectRole")}
                required
              />
              <TextFieldHookForm
                name="roleTitle"
                label={i18n.t("roleTitle")}
                placeholder={i18n.t("typeRoleTitle")}
              />
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button onClick={onToggle} variant="text" useTypography size="sm">
              {i18n.t("cancel")}
            </Button>
            <Button
              variant="contained"
              type="submit"
              size="sm"
              loading={loading}
              startIcon={<Save01Icon fontSize="small" />}
              useTypography
            >
              {i18n.t("save")}
            </Button>
          </DialogActions>
        </LoadingOverlay>
      </FormContainer>
    </Dialog>
  );
};

export default EmployeeDialog;
